import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=5e52574b&scoped=true&"
import script from "./AppDrawer.vue?vue&type=script&lang=js&"
export * from "./AppDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=5e52574b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e52574b",
  null
  
)

export default component.exports